<div class="text-gradient-container">
    <div class="heading">
        <h3>{{ "control_text_gradient_title" | translate }}</h3>
        <span class="cls-btn" (click)="onClose()">
            <svg width="24" height="24" focusable="false">
                <path
                    d="M17.3 8.2L13.4 12l3.9 3.8a1 1 0 01-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 01-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 011.5-1.5l3.8 3.9 3.8-3.9a1 1 0 011.5 1.5z"
                    fill-rule="evenodd"
                ></path>
            </svg>
        </span>
    </div>
    <div class="body">
        <div class="picker-wrapper">
            <span
                #ignoredInput
                [cpIgnoredElements]="[ignoredInput]"
                [cpToggle]="true"
                [(colorPicker)]="colorValue"
                cpOutputFormat="rgba"
                cpDialogDisplay="inline"
                cpWidth="160px"
            ></span>

            <small class="text-muted alpha-value"
                >{{ "control_color_opacity" | translate }}: {{ getAlphaFromRgba(colorValue) }}%</small
            >
        </div>

        <div class="control-wrapper">
            <div class="preset-gradient-bg" [style.background]="getGradientBgStyle(gradientText)">
                @for (value of gradientText.values; track $index; let i = $index) {
                    <div class="presets-wrapper">
                        <div
                            class="preset-color"
                            [class.selected]="i === gradientValueIndex"
                            (click)="setGradientValueIndex(i)"
                            [style.background]="value.color"
                        ></div>
                    </div>
                }
            </div>

            <div class="spc-color-picker-input mb-10">
                <input
                    type="text"
                    [class.error-inp]="formColor.invalid"
                    [ngModel]="colorValue | rgbaToHex"
                    (ngModelChange)="changeColorHandler($event)"
                    maxlength="7"
                    class="spc-color-picker-input-name form-control"
                />
                <span class="spc-color-picker-input-area" [style.background]="colorValue">
                    <sp-transparent-icon [color]="gradientColor" />
                </span>
            </div>

            <div class="input-group">
                <input
                    class="form-control"
                    type="number"
                    max="360"
                    min="0"
                    [ngModel]="degValue"
                    (ngModelChange)="changeDegHandler($event)"
                />
                <span class="input-group-addon">deg°</span>
            </div>
        </div>
    </div>

    <div class="hint-wrapper small">
        <span class="sp-icon icon-info-bold color-light"> </span>
        <span class="text-muted">{{ "text_gradient_info_hint" | translate }}</span>
    </div>

    <div class="footer">
        <button class="btn btn-action btn-sm" (click)="onClose()">{{ "cancel" | translate }}</button>
        <button class="btn btn-primary btn-sm" (click)="onConfirm()">{{ "save" | translate }}</button>
    </div>
</div>
